import { RichTextRenderer } from '@contember/react-client'
import Link from 'next/link'
import type React from 'react'
import { useMemo } from 'react'
import type { ContentReferenceResult } from '../../data/ContentFragment'
import type { ContentTextBlockResult } from '../../data/ContentTextFragment'

export type AnchorElement = {
	type: 'anchor'
	href: string
}

export type CustomElement = AnchorElement

export function ContentText(props: { blocks: ContentTextBlockResult[] }) {
	const { blocks } = props
	const nestedTypes = useMemo(() => ['listItem', 'anchor', 'tableCell', 'tableRow', 'scrollTarget', 'link'], [])
	return useMemo(
		() => (
			<RichTextRenderer
				blocks={blocks}
				sourceField="json"
				renderBlock={(props: { block: unknown; children?: React.ReactNode }) => {
					return <>{props.children}</>
				}}
				renderLeaf={(props) => {
					return props.fallback
				}}
				renderElement={(props) => {
					const type = props.element.type

					if (nestedTypes.includes(type)) {
						const reference = props.reference as ContentReferenceResult
						if (props.referenceType === 'link' && reference.link) {
							return (
								reference.link.externalLink && (
									<Link href={reference.link.externalLink} target={reference.link.isTargetBlank ? '_blank' : ''}>
										{props.children}
									</Link>
								)
							)
						}

						return props.fallback
					}
					return props.fallback
				}}
			/>
		),
		[blocks, nestedTypes],
	)
}
